// @ts-nocheck
import MarketingLayout from "@/components/MarketingLayout";

import {
  ArchiveIcon,
  ClipboardCheckIcon,
  LightBulbIcon,
  PresentationChartBarIcon,
  RefreshIcon,
} from "@heroicons/react/outline";
import { useState } from "react";
import { Switch } from "@headlessui/react";
import { POST_HEADERS } from "@/lib/apiRequests";
import { toast } from "react-hot-toast";

function Pricing() {
  const [enabled, setEnabled] = useState(false);

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const submitContactEmail = async (e) => {
    e.preventDefault();

    const emailEntry = e.target[0].value;

    let toastId;

    try {
      toastId = toast.loading("Loading...");
      const request = await fetch("/api/email-contact", {
        ...POST_HEADERS,
        body: JSON.stringify({
          contactEmail: emailEntry,
        }),
      });

      toast.success("Success!");
      toast.dismiss(toastId);

      e.target.reset();
    } catch (error) {
      toast.error("Unable to add to list", { id: toastId });
      console.log("error", error);
    }
  };

  return (
    <MarketingLayout name="pricing">
      <h1 className="w-11/12 mx-auto max-w-4xl marketing-text-gradient  text-4xl lg:text-6xl font-bold text-center mt-12 mb-12 mx-auto">
        Survyy is a better way to gather feedback from your clients
      </h1>
      <p
        id="early-access"
        className="text-gray-200 text-center max-w-xl m-auto pb-12 w-11/12 mx-auto"
      >
        Meet the new standard for modern feedback collection and analysis.
        Streamline team health checkins, onboarding, project satisfaction
        responses, and so much more.
      </p>
      <form
        method="post"
        onSubmit={submitContactEmail}
        className="mktg-input-ctn w-11/12 mx-auto shadow-lg mt-1 flex justify-start my-6 m-auto rounded-3xl bg-gray-700 bg-opacity-90 relative w-auto max-w-md mktg-input-ctn"
      >
        <input
          type="email"
          name="email"
          id="email"
          className="bg-gray-700 bg-opacity-0 placeholder-opacity-50 placeholder-white border-0 w-auto rounded-3xl block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm px-6"
          placeholder="team@survvy.com"
        />
        <input
          type="submit"
          value="get early access"
          className="rounded-3xl  py-2 px-4 text-white absolute right-0 marketing-btn-gradient"
        ></input>
      </form>
      <div id="features" className="max-w-4xl mx-auto py-12 w-11/12 mx-auto">
        <div className="mb-12 flex">
          <div className="pr-4">
            <LightBulbIcon className="h-14 w-14 text-white"></LightBulbIcon>
          </div>
          <div className="">
            <h2 className="marketing-text-gradient text-2xl lg:text-5xl pb-4 font-bold">
              Gain deeper insight through AI
            </h2>
            <p className="text-gray-200 text-lg">
              Meet the new standard for modern feedback collection and analysis.
              Streamline team health checkins, onboarding, project satisfaction
              responses, and so much more.
            </p>
          </div>
        </div>
        <div className="mb-12 flex">
          <div className="pr-4">
            <PresentationChartBarIcon className="h-14 w-14 text-white"></PresentationChartBarIcon>
          </div>
          <div className="">
            <h2 className="marketing-text-gradient text-2xl lg:text-5xl pb-4 font-bold">
              Segment your surveys by groups
            </h2>
            z
            <p className="text-gray-200 text-lg">
              Meet the new standard for modern feedback collection and analysis.
              Streamline team health checkins, onboarding, project satisfaction
              responses, and so much more.
            </p>
          </div>
        </div>
        <div className="mb-12 flex">
          <div className="pr-4">
            <RefreshIcon className="h-14 w-14 text-white"></RefreshIcon>
          </div>
          <div className="">
            <h2 className="marketing-text-gradient text-2xl lg:text-5xl pb-4 font-bold">
              Customized to your brand
            </h2>
            <p className="text-gray-200 text-lg">
              Meet the new standard for modern feedback collection and analysis.
              Streamline team health checkins, onboarding, project satisfaction
              responses, and so much more.
            </p>
          </div>
        </div>
        <div className="mb-12 flex">
          <div className="pr-4">
            <ClipboardCheckIcon className="h-14 w-14 text-white"></ClipboardCheckIcon>
          </div>
          <div className="">
            <h2 className="marketing-text-gradient text-2xl lg:text-5xl pb-4 font-bold">
              Integrate with your favorite tools
            </h2>
            <p className="text-gray-200 text-lg">
              Meet the new standard for modern feedback collection and analysis.
              Streamline team health checkins, onboarding, project satisfaction
              responses, and so much more.
            </p>
          </div>
        </div>
        <div className="mb-12 flex">
          <div className="pr-4">
            <ArchiveIcon className="h-14 w-14 text-white"></ArchiveIcon>
          </div>
          <div className="">
            <div className="flex flex flex-col items-start lg:flex-row lg:items-center">
              <h2 className="marketing-text-gradient text-2xl lg:text-5xl pb-2 lg:pb-4 font-bold">
                Go from insight to action
              </h2>
              <div className="rounded-3xl flex items-center py-2 px-4 h-8 text-white mb-4 lg:ml-4 coming-soon">
                coming soon!
              </div>
            </div>
            <p className="text-gray-200 text-lg">
              Meet the new standard for modern feedback collection and analysis.
              Streamline team health checkins, onboarding, project satisfaction
              responses, and so much more.
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 mx-auto mb-8 lg:block pricing-section pl-4 pr-0 md:p-0">
        <h2
          id="pricing"
          className="marketing-text-gradient text-2xl lg:text-5xl pb-4 font-bold"
        >
          Pricing
        </h2>

        <div className="flex w-full table-section overflow-x-scroll pr-4 sm:pr-0">
          <div className="py-4 w-1/4 table-column-parent">
            <div className="table-container  rounded-md rounded-r-none h-full flex items-end">
              <table className="min-w-full divide-y divide-gray-300 divide-opacity-20 > *">
                <thead className="rounded-3xl">
                  <tr className="">
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-200 sm:pl-6 flex flex-col"
                    >
                      <div className="pb-2 text-gray-200 text-lg font-bold">
                        Billing Cycle
                      </div>
                      <Switch.Group as="div" className="flex items-center">
                        <Switch
                          checked={enabled}
                          onChange={setEnabled}
                          className={classNames(
                            enabled ? "bg-indigo-700" : "bg-gray-200",
                            "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                          )}
                        >
                          <span
                            aria-hidden="true"
                            className={classNames(
                              enabled ? "translate-x-5" : "translate-x-0",
                              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                            )}
                          />
                        </Switch>
                        <Switch.Label as="span" className="ml-3">
                          {" "}
                          <span
                            className={classNames(
                              enabled ? "mentor-access" : "text-gray-200",
                              "text-sm font-medium"
                            )}
                          >
                            Annual billing
                          </span>
                          <span className="pl-2 text-sm text-gray-200">
                            (Save $$)
                          </span>
                        </Switch.Label>
                      </Switch.Group>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 divide-opacity-20 > *">
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      Recipients
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      Survey Templates
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      AI Sentiment Analysis
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      Integrations
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      Custom Branding
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-white">
                      SSO
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200">
                      Workspace Users
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-md font-bold text-gray-200 flex flex-col">
                      Mentor Access{" "}
                      <span className="mentor-access font-light">
                        coming soon!
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="py-4 w-1/4 table-column-parent">
            <div className="table-container  h-full">
              <table className="min-w-full divide-y divide-gray-300 divide-opacity-20 > *">
                <thead className="rounded-3xl">
                  <tr className="">
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                    >
                      <div className="p-4">
                        <h2 className="text-gray-200 text-3xl pb-2">Free</h2>
                        <h2 className="text-gray-200 text-5xl">
                          $0{" "}
                          <span className="text-gray-200 text-xs">
                            per month
                          </span>
                        </h2>
                      </div>
                      <a
                        href="#early-access"
                        className="rounded-3xl  py-2 px-4 text-white marketing-btn-gradient"
                      >
                        get early access
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 divide-opacity-20 > *">
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ 10
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ 2
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200"></td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200"></td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200"></td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white">
                      ✓ G-Suite
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ 1 Users
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className=" w-1/4 table-column-parent">
            <div className="table-container table-alt rounded-md h-full">
              <table className="min-w-full divide-y divide-gray-300 divide-opacity-20 > *">
                <thead className="rounded-3xl">
                  <tr className="">
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                    >
                      <div className="p-4">
                        <h2 className="text-white text-3xl pb-2">Standard</h2>
                        <h2
                          className={classNames(
                            enabled ? "text-opacity-0 hidden" : "block fade-in",
                            "text-white text-5xl"
                          )}
                        >
                          $25{" "}
                          <span className="text-white text-xs">per month</span>
                        </h2>
                        <h2
                          className={classNames(
                            enabled ? "block fade-in" : "text-opacity-0 hidden",
                            "text-white text-5xl"
                          )}
                        >
                          $275{" "}
                          <span className="text-white text-xs">per year</span>
                        </h2>
                      </div>
                      <a
                        href="#early-access"
                        className="rounded-3xl  py-2 px-4 text-white marketing-btn-gradient"
                      >
                        get early access
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 divide-opacity-20 > *">
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white">
                      ✓ unlimited
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white">
                      ✓ unlimited
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 empty-cell text-sm text-white"></td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white"></td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white">
                      ✓ included
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-white">
                      ✓ G-Suite
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ 3 Users
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ included
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="py-4 w-1/4 table-column-parent">
            <div className="table-container  rounded-l-none rounded-md h-full">
              <table className="min-w-full divide-y divide-gray-300 divide-opacity-20 > *">
                <thead className="rounded-3xl">
                  <tr className="">
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-200"
                    >
                      <div className="p-4">
                        <h2 className="text-gray-200 text-3xl pb-2">Premium</h2>
                        <h2
                          className={classNames(
                            enabled ? "text-opacity-0 hidden" : "block fade-in",
                            "text-white text-5xl"
                          )}
                        >
                          $30{" "}
                          <span className="text-gray-200 text-xs">
                            per month
                          </span>
                        </h2>
                        <h2
                          className={classNames(
                            enabled ? "block fade-in" : "text-opacity-0 hidden",
                            "text-white text-5xl"
                          )}
                        >
                          $320{" "}
                          <span className="text-gray-200 text-xs">
                            per year
                          </span>
                        </h2>
                      </div>
                      <a
                        href="#early-access"
                        className=" rounded-3xl  py-2 px-4 text-white marketing-btn-gradient"
                      >
                        get early access
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 divide-opacity-20 > *">
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ unlimited
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ unlimited
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ included
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ unlimited
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ included
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ G-Suite
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ 10 Users
                    </td>
                  </tr>
                  <tr>
                    <td className="whitespace-nowrap px-6 py-2 text-sm text-gray-200">
                      ✓ included
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}

export default Pricing;
